// P&L: Google's own billed cost for each Google project, the same feed the Firebase Usage tab
// uses (the Apps Script "getUsage" action, which reads the Cloud Billing export).
// Costs come in dollars (or rupees if the export is in rupees) and are changed to rupees here.
// If today's dollar rate cannot be fetched, nothing is booked (no guessing).
import { getAuth } from "firebase/auth";

const USAGE_URL = "https://script.google.com/macros/s/AKfycbxrzbBnegelyWenzq3yIdZeyhi2pHOZUjxsLUcycC2FSscPtYv6n6WfVcA49XGZzvG0/exec";
const RATE_URL = "https://api.frankfurter.dev/v1/latest?from=USD&to=INR";

export async function fetchGoogleCostsInr(googleProjectIds) {
  const user = getAuth().currentUser;
  if (!user) throw new Error("You need to be signed in.");
  const idToken = await user.getIdToken();
  const resp = await fetch(USAGE_URL, {
    method: "POST",
    headers: { "Content-Type": "text/plain" }, // same as Firebase Usage: avoids a CORS preflight
    body: JSON.stringify({ action: "getUsage", idToken, targetProjectIds: googleProjectIds }),
  });
  const json = await resp.json();
  if (!json.success) throw new Error(json.error || "Google cost could not be read.");

  let rate = null;
  try {
    const r = await (await fetch(RATE_URL)).json();
    if (r && r.rates && Number(r.rates.INR) > 0) rate = Number(r.rates.INR);
  } catch (e) { /* handled below */ }

  const costs = {};
  (json.projects || []).forEach((p) => {
    const c = p && p.costSinceStart;
    if (!c || !Number.isFinite(Number(c.amount))) return;
    if (c.currency === "INR") costs[p.projectId] = Number(c.amount);
    else if (rate) costs[p.projectId] = Number(c.amount) * rate;
  });
  if (!rate && (json.projects || []).some((p) => p && p.costSinceStart && p.costSinceStart.currency !== "INR")) {
    throw new Error("Today's dollar rate could not be fetched. Try again in a minute.");
  }
  return { costs, rate };
}
